// src/supabase/index.ts — typed Supabase client, singleton per page.
import { createClient } from '@supabase/supabase-js';
const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;
let _client = null;
/**
 * Returns a memoized typed Supabase client.
 * Throws a friendly setup error if env isn't configured — not a cryptic `undefined`.
 */
export function getSupabase() {
    if (_client)
        return _client;
    if (!url || !anon || url.includes('REPLACE_ME') || anon.includes('REPLACE_ME') || anon.includes('demo_placeholder')) {
        throw new SupabaseNotConfiguredError();
    }
    _client = createClient(url, anon, {
        auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    });
    return _client;
}
export const supabase = new Proxy({}, {
    get(_t, prop) { return getSupabase()[prop]; },
});
export class SupabaseNotConfiguredError extends Error {
    code = 'supabase_not_configured';
    constructor() {
        super("Supabase isn't configured yet. Run `npm run setup` or open /setup in the app.");
    }
}
